import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './no-auth/login/login.component';
import { MfaLoginComponent } from './no-auth/mfa-login/mfa-login.component';
import { FirstMfaSetupComponent } from './no-auth/first-mfa-setup/first-mfa-setup.component';
import { LayoutComponent } from './auth/layout/layout.component';
import { DashboardComponent } from './auth/dashboard/dashboard.component';
import { CountryComponent } from './auth/masters/country/country.component';
import { CurrencyComponent } from './auth/masters/currency/currency.component';
import { CountryCurrencyComponent } from './auth/masters/country-currency/country-currency.component';
import { ProviderComponent } from './auth/masters/provider/provider.component';
import { ConversionComponent } from './auth/conversion/conversion.component';
import { SettingsComponent } from './auth/settings/settings.component';
import { CustomersComponent } from './auth/customers/customers.component';
import { TransactionsComponent } from './auth/transactions/transactions.component';
import { UsersComponent } from './auth/users/users.component';
import { DisputesComponent } from './auth/disputes/disputes.component';
import { ReportsComponent } from './auth/reports/reports.component';
import { ForgotPasswordComponent } from './no-auth/forgot-password/forgot-password.component';
import { RbacComponent } from './auth/rbac/rbac.component';
import { RefundsComponent } from './auth/refunds/refunds.component';
import { LedgersComponent } from './auth/ledgers/ledgers.component';
import { PartnersComponent } from './auth/partners/partners.component';

import { CountryDynamicFieldsComponent } from './auth/masters/country/dynamicfields/dynamicfields.component';
import { CountryRemittanceConfigComponent } from './auth/masters/country/remittance-config/remittance-config.component';
import { SettlementsComponent } from './auth/settlements/settlements.component';
import { PackagesComponent } from './auth/airalo/packages/packages.component';
import { OrdersComponent } from './auth/airalo/orders/orders.component';
import { OrderDetailsComponent } from './auth/airalo/orders/order-details/order-details.component';
import { SimsComponent } from './auth/airalo/sims/sims.component';
import { SimDetailsComponent } from './auth/airalo/sims/sim-details/sim-details.component';
import { SimUsageComponent } from './auth/airalo/sims/sim-usage/sim-usage.component';
import { SimPackageHistoryComponent } from './auth/airalo/sims/sim-package-history/sim-package-history.component';
import { SimInstructionsComponent } from './auth/airalo/sims/sim-instructions/sim-instructions.component';
import { SimCompatibleDevicesComponent } from './auth/airalo/sims/sim-compatible-devices/sim-compatible-devices.component';
import { BalanceComponent } from './auth/airalo/balance/balance.component';
import { CustomerDetailsComponent } from './auth/customers/customer-details/customer-details.component';
import { BeneficiaryTransactionsComponent } from './auth/customers/beneficiary-transactions/beneficiary-transactions.component';
import { MfaComponent } from './auth/settings/mfa/mfa.component';
import { CustomerLimitsComponent } from './auth/customer-limits/customer-limits.component';
import { PartnerLimitsComponent } from './auth/partner-limits/partner-limits.component';
import { BillsComponent } from './auth/bills/bills.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { SecurityQuestionsComponent } from './auth/settings/security-questions/security-questions.component';
import { authGuard } from './shared/helpers/auth.guard';
import { mfaAuthGuard } from './shared/helpers/mfa-auth.guard';
import { adminGuard } from './shared/helpers/admin.guard';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'mfa-login', component: MfaLoginComponent, canActivate: [authGuard] },
  { path: 'first-mfa-setup', component: FirstMfaSetupComponent, canActivate: [authGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [authGuard] },
  {
    path: 'app', component: LayoutComponent, canActivate: [mfaAuthGuard],
    children: [
      { path: '', component: DashboardComponent },
      { path: 'country', component: CountryComponent },
      { path: 'currency', component: CurrencyComponent },
      { path: 'provider', component: ProviderComponent },
      { path: 'countries/:id/dynamic', component: CountryDynamicFieldsComponent },
      { path: 'countries/:id/remittance', component: CountryRemittanceConfigComponent },
      { path: 'country-currency', component: CountryCurrencyComponent },
      { path: 'conversion', component: ConversionComponent },
      { path: 'users', component: UsersComponent, canActivate: [adminGuard] },
      { path: 'customers', component: CustomersComponent, canActivate: [adminGuard] },
      { path: 'customers/details', component: CustomerDetailsComponent, canActivate: [adminGuard] },
      { path: 'customers/beneficiary-transactions', component: BeneficiaryTransactionsComponent, canActivate: [adminGuard] },
      { path: 'transactions', component: TransactionsComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'disputes', component: DisputesComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'rbac', component: RbacComponent, canActivate: [adminGuard] },
      { path: 'refunds', component: RefundsComponent },
      { path: 'ledgers', component: LedgersComponent },
      { path: 'partners', component: PartnersComponent },

      { path: 'settlements', component: SettlementsComponent },
      { path: 'packages', component: PackagesComponent },
      { path: 'orders', component: OrdersComponent },
      { path: 'orders/:id', component: OrderDetailsComponent },
      { path: 'sims', component: SimsComponent },
      { path: 'sims/:iccid', component: SimDetailsComponent },
      { path: 'sims/:iccid/usage', component: SimUsageComponent },
      { path: 'sims/:iccid/packages', component: SimPackageHistoryComponent },
      { path: 'sims/:iccid/instructions', component: SimInstructionsComponent },
      { path: 'sims/:iccid/compatible-devices', component: SimCompatibleDevicesComponent },
      { path: 'compatible-devices', component: SimCompatibleDevicesComponent },
      { path: 'balance', component: BalanceComponent },
      { path: 'mfa', component: MfaComponent },
      { path: 'customer-limits', component: CustomerLimitsComponent, canActivate: [adminGuard] },
      { path: 'partner-limits', component: PartnerLimitsComponent, canActivate: [adminGuard] },
      { path: 'bills', component: BillsComponent },
      { path: 'security-questions', component: SecurityQuestionsComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }